import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-partner-detail',
  templateUrl: './business-partner-detail.component.html',
  styleUrls: ['./business-partner-detail.component.scss']
})
export class BusinessPartnerDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
